import {
  INIT_SIGNIN,
  CHANGE_FREETRIAL_STATUS,
  UPDATE_REFERRAL_MODAL,
  SET_TRIAL_STATUS,
  UPDATE_SIGNUP_PATH,
  UPDATE_PURCHASED_PATH,
  UPDATE_EXISTING_USER_STATUS,
  UPDATE_PAYMENT_STATUS,
  UPDATE_BACKGROUND_THEME,
  INIT_SIGNOUT,
  UPDATE_PROFILE,
  UPDATE_NAME,
  SET_ACCESS_TOKEN,
  INIT_AFFILIATE_USER,
  UPDATE_STUDENT_MODAL_STATUS,
  REFERRAL_REDEEM_STATUS,
  OTP_VERIFYID,
  UPDATE_MYCOURSES,
  UPDATE_PHONE_NO_VERIFIED,
  UPDATE_REFERRAL_PAYMENT_INFO,
  UPDATE_USER_LEGALNAME,
  SAVE_LINKEDIN_POST,
  SAVE_USER_PROGRESS,
  SAVE_USER_PROFILE_DETAILS,
  UPDATE_USER_LOCATION_DETAILS,
  UPDATE_USER_LOCATION_FROM,
  UPDATE_USER_SURVEY_ANSWER,
  SAVE_PHONENUMBER_MODEL,
  TOGGLE_SITE_THEME,
} from '../Actions/actionTypes';
import navigator from '../utils/navigator';

const INIT_STATE = {
  userSession: false,
  username: null,
  name: 'User',
  token: null,
  loginType: false,
  email: null,
  phoneNumber: null,
  phoneNoVerified: false,
  picture: 'https://s3.ap-south-1.amazonaws.com/assets.log2base2.com/Assets/User_Icon.svg',
  foundationStatus: false,
  paymentStatus: false,
  trialStatus: true,
  signup_path: null,
  purchasedPaths: null,
  bgTheme: true,
  darkTheme: false,
  optionModalStatus: false,
  mailModalStatus: false,
  redeemStatus: false,
  OTPverifyID: '',
  referralModal: true,
  myCourses: [],
  legalName: false,
  locationDetails: {},
  userSurveyAnswer: [],
  surveyphoneNoChecked: true,
};

const User = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_SIGNIN:
      return {
        ...state,
        ...action.user,
      };

    case INIT_SIGNOUT:
      navigator.unloadSession();
      return INIT_STATE;

    case UPDATE_PROFILE:
      return {
        ...state,
        picture: action.picture,
        phoneNumber: action.phoneNumber,
        phoneNoVerified: action.phoneNoVerified,
      };
    case UPDATE_PHONE_NO_VERIFIED:
      return {
        ...state,
        phoneNoVerified: action.phoneNoVerified,
      };

    case CHANGE_FREETRIAL_STATUS:
      return {
        ...state,
        trialStatus: action.status,
      };

    case UPDATE_MYCOURSES:
      return {
        ...state,
        myCourses: action.mycourses,
      };

    case SET_TRIAL_STATUS:
      return {
        ...state,
        ...action.details,
      };

    case UPDATE_SIGNUP_PATH:
      return {
        ...state,
        signup_path: action.signup_path,
      };

    case SAVE_PHONENUMBER_MODEL:
      return {
        ...state,
        surveyphoneNoChecked: action.status,
      };

    case UPDATE_PURCHASED_PATH:
      return {
        ...state,
        purchasedPaths: action.purchasedPaths,
      };

    case UPDATE_BACKGROUND_THEME:
      return {
        ...state,
        bgTheme: action.themeStatus,
      };

    case TOGGLE_SITE_THEME:
      return {
        ...state,
        darkTheme: action.themeStatus,
      };

    case UPDATE_EXISTING_USER_STATUS:
      return {
        ...state,
        existingUser: action.status,
      };

    case UPDATE_REFERRAL_MODAL:
      return {
        ...state,
        referralModal: action.status,
      };

    case UPDATE_PAYMENT_STATUS:
      return {
        ...state,
        foundationStatus: action.foundationStatus,
        paymentStatus: action.paymentStatus,
        trialStatus: action.paymentStatus === true ? false : state.trialStatus,
      };

    case UPDATE_NAME:
      return {
        ...state,
        name: action.name,
        picture: action.profilePic,
      };

    case INIT_AFFILIATE_USER:
      return {
        ...state,
        affiliateID: action.id,
      };

    case SET_ACCESS_TOKEN:
      return {
        ...state,
        token: action.token,
      };

    case UPDATE_STUDENT_MODAL_STATUS:
      return {
        ...state,
        optionModalStatus: action.optionModalStatus,
        mailModalStatus: action.mailModalStatus,
      };

    case REFERRAL_REDEEM_STATUS:
      return {
        ...state,
        redeemStatus: action.status,
      };

    case OTP_VERIFYID: {
      return {
        ...state,
        OTPverifyID: action.verifyID,
      };
    }
    case UPDATE_REFERRAL_PAYMENT_INFO:
      return {
        ...state,
        referralPaymentInfo: action.referralInfo.referralPaymentInfo,
        phoneNumber: action.referralInfo.phoneNumber,
      };

    case UPDATE_USER_LEGALNAME: {
      return {
        ...state,
        legalName: action.legalName,
        code: action.code,
        certificateSharedStatus: action.status,
      };
    }

    case UPDATE_USER_LOCATION_DETAILS: {
      return {
        ...state,
        locationDetails: action.locationDetails,
      };
    }

    case UPDATE_USER_LOCATION_FROM: {
      return {
        ...state,
        locationDetails: action.details,
      };
    }

    case UPDATE_USER_SURVEY_ANSWER: {
      return {
        ...state,
        userSurveyAnswer: action.answerDetails,
      };
    }
    case SAVE_LINKEDIN_POST: {
      return {
        ...state,
        postText: action.postText,
        certificateImage: action.image,
        certificateIssued: action.issuedStatus,
      };
    }

    case SAVE_USER_PROGRESS: {
      return {
        ...state,
        userProgress: action.userProgress,
      };
    }

    case SAVE_USER_PROFILE_DETAILS: {
      return {
        ...state,
        profileDetails: action.profileDetails,
      };
    }

    default:
      return state;
  }
};

export default User;
